/* ============================================================
   SARANICE Quick View
   - 卡片 [data-quick-view] 点击 → 弹窗
   - 内容来自 /products/{handle}?section_id=quick-view
   - 加购走 /cart/add.js（sections=cart-drawer,cart-icon-bubble）
   事件全部委托在 overlay 上，注入内容无需重新绑定。
   ============================================================ */
(function () {
  'use strict';

  var overlay = null;
  var lastFocus = null;

  function ensureShell() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'qv-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="qv-modal" role="dialog" aria-modal="true" aria-label="Product quick view">' +
      '<button type="button" class="qv-close" aria-label="Close">&#215;</button>' +
      '<div class="qv-content"></div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      // 点遮罩空白处关闭
      if (e.target === overlay) { close(); return; }
      var t = e.target;
      var thumb = t.closest('.qv-thumb');
      if (thumb) {
        var main = overlay.querySelector('[data-qv-main]');
        if (main && thumb.dataset.full) main.src = thumb.dataset.full;
        overlay.querySelectorAll('.qv-thumb').forEach(function (b) { b.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        return;
      }
      if (t.closest('.qv-close')) { close(); }
    });

    // 规格切换（change 委托）
    overlay.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-qv-select]');
      if (!sel) return;
      var variants = getVariants();
      var v = variants.find(function (x) { return String(x.id) === sel.value; });
      if (!v) return;
      var idInput = overlay.querySelector('[data-qv-id-input]');
      var price = overlay.querySelector('[data-qv-price]');
      var addBtn = overlay.querySelector('[data-qv-add]');
      if (idInput) idInput.value = v.id;
      if (price) price.textContent = v.money;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    });

    // 加购（submit 委托）
    overlay.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-qv-form]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });

    return overlay;
  }

  function getVariants() {
    var node = overlay.querySelector('[data-qv-variants]');
    if (!node) return [];
    try { return JSON.parse(node.textContent); } catch (err) { return []; }
  }

  function open(url) {
    var shell = ensureShell();
    lastFocus = document.activeElement;
    var box = shell.querySelector('.qv-content');
    box.innerHTML = '<div class="qv-status" style="padding:40px;text-align:center">Loading&#8230;</div>';
    shell.hidden = false;
    requestAnimationFrame(function () { shell.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';

    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=quick-view', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('[data-qv-root]');
        if (!root) throw new Error('no quick-view section');
        box.innerHTML = '';
        box.appendChild(root);
        var closeBtn = shell.querySelector('.qv-close');
        if (closeBtn) closeBtn.focus();
      })
      .catch(function () {
        box.innerHTML =
          '<p class="qv-status is-error" style="padding:32px;text-align:center">' +
          'Could not load the preview. ' +
          '<a href="' + url + '">Open the product page</a></p>';
      });
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var done = function () {
      overlay.hidden = true;
      overlay.querySelector('.qv-content').innerHTML = '';
    };
    setTimeout(done, 220);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function setStatus(form, msg, isError) {
    var el = form.querySelector('[data-qv-status]');
    if (!el) return;
    el.hidden = !msg;
    el.textContent = msg || '';
    el.classList.toggle('is-error', !!isError);
  }

  // 本站点无 cart-drawer（购物车主體是 /cart 页面），加购成功后给一个直达链接
  function addedLink(form) {
    var el = form.querySelector('[data-qv-status]');
    if (!el) return;
    el.hidden = false;
    el.innerHTML = '';
    el.appendChild(document.createTextNode('✓ Added to cart — '));
    var a = document.createElement('a');
    a.href = '/cart';
    a.textContent = 'View cart';
    el.appendChild(a);
  }

  function addToCart(form) {
    var idInput = form.querySelector('[data-qv-id-input]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var btn = form.querySelector('[data-qv-add]');
    var id = idInput && idInput.value;
    if (!id) return;
    var body = {
      id: parseInt(id, 10),
      quantity: Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1),
      sections: 'cart-drawer,cart-icon-bubble'
    };
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    setStatus(form, '', false);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        if (!res.ok) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add to cart.';
          setStatus(form, msg, true);
          return;
        }
        updateCartIcon(res.data);
        var opened = tryOpenDrawer(res.data);
        if (!opened) addedLink(form);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        setStatus(form, 'Network error. Please try again.', true);
      });
  }

  function updateCartIcon(data) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !data.sections || !data.sections['cart-icon-bubble']) return;
    var html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
    var fresh = html.querySelector('.shopify-section');
    if (fresh) bubble.innerHTML = fresh.innerHTML;
  }

  function tryOpenDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !data.sections || !data.sections['cart-drawer']) return false;
    try {
      var html = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var fresh = html.querySelector('cart-drawer');
      if (!fresh) return false;
      drawer.innerHTML = fresh.innerHTML;
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      return false;
    } catch (err) { return false; }
  }

  // 全局点击委托：打开预览
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn.getAttribute('data-qv-url') || btn.getAttribute('data-product-url') || '');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && !overlay.hidden) close();
  });
})();
